<template>
  <div class="resultStatus resultCanceled full-width full-height flex column justify-center text-center q-px-lg">
    <div v-if="serviceTypeStatus !== 'DELIVERY'">
      <!-- <q-img src="~src/assets/images/result/Upset.png" /> -->
      <q-icon name="app:ku" />
      <div class="title font-size-24 text-weight-bolder">
        <span v-if="isOVO">
          {{ ovoTitleStr }}
        </span>
        <span v-else>
          {{ $t('result.cancelMsg1') }}
        </span>
      </div>
      <div class="desc font-size-12 text-theme-gray q-my-sm">
        <span v-if="isOVO">
          {{ ovoStr }}
        </span>
        <span v-else class="refund-text">
          <span v-if="orderRefund.refundHeader.onLineRefund && orderRefund.refundHeader.statusId !== 'FAILED'">{{
              $t('result.cancelMsg7')
            }}</span>
          <span v-if="!orderRefund.refundHeader.onLineRefund || orderRefund.refundHeader.statusId === 'FAILED'">{{
              $t('result.cancelMsg8') }}</span>
        </span>
      </div>
    </div>
    <!--  -->
    <div v-if="isCanceledDELIVERY">
      <!-- <q-img src="~src/assets/images/result/Upset.png" /> -->
      <q-icon name="app:ku" />
      <div class="title font-size-24 text-weight-bolder">
        <strong v-if="isOVO">
          {{ ovoTitleStr }}
        </strong>
        <strong v-else>{{ $t('result.cancelMsg3') }}</strong>
      </div>
      <div class="desc font-size-12 text-theme-gray q-my-sm">
        <template v-if="isOVO">
          {{ ovoStr }}
        </template>
        <template v-else>
          <span class="refund-text">
            <span v-if="orderRefund.refundHeader.onLineRefund">{{ $t('result.cancelMsg7') }}</span>
            <span v-if="!orderRefund.refundHeader.onLineRefund">{{ $t('result.cancelMsg8') }}</span>
          </span>
        </template>
      </div>
    </div>

    <div class="order-cancel-container">
      <CancelReasonTrack
        v-if="orderRefund.refundHeader.onLineRefund && orderRefund.refundHeader.statusId !== 'FAILED'"
        class="cancel-track"
/>
      <div class="cancel-reason-container">
        <h6 class="title">{{ $t("result.cancel.refund.reasonCancel.title") }}</h6>
        <p class="reason-label">{{ cancelReason }}</p>
        <p v-if="orderRefund.refundHeader.refundReasonDesc" class="reason-desc">{{ orderRefund.refundHeader.refundReasonDesc }}</p>
      </div>

      <div
        v-if="!orderRefund.refundHeader.onLineRefund || orderRefund.refundHeader.statusId === 'FAILED'"
           class="cancel-contact-container"
>
        <a class="contact-phone" :href="`tel:${sellerPhone}`" target="_blank">
          <q-icon
            name="app:iphone_icon"
            size="24px"
            class="contact-icon"
          />
        </a>
        <a class="contact-btn" :href="`https://wa.me/${sellerPhone}`" target="_blank">{{ $t("result.cancel.refund.contactWhatsApp") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { getCancelReasonList } from 'src/api/order.js'
import orderMixins from 'pages/mixin/orderMixins.js';
import CancelReasonTrack from 'pages/result/components/CancelReasonTrack.vue';
import { mapState } from 'vuex';

export default {
  components: {
    CancelReasonTrack
  },
  mixins: [orderMixins],
  inject: {
    orderData: {}
  },
  props: {
    mealCode: {
      type: String,
      default: '',
    },
    detail: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      code: this.mealCode,
      serviceTypeStatus: '',
      shipmentStatusCode: '',
      paymentMethodType: '',
      paymentMethodTypeId: '',
      needOfflineRefund: false,
      ovoTitleStr: '',
      ovoStr: '',
      cancelHash: {}
    };
  },
  computed: {
    ...mapState({
      language: state => state.Menu.language
    }),
    orderRefund() {
      if (!this.orderData.orderDetail?.payments) {
        return {
          refundHeader: { refundReason: '' }
        };
      }
      return this.orderData.orderDetail.payments[0].orderRefund
    },
    cancelReason() {
      if (this.language === 'id-ID') {
        return (this.cancelHash[this.orderRefund.refundHeader.refundReason] &&
          this.cancelHash[this.orderRefund.refundHeader.refundReason].idDesc) || '--'
      }
      return (this.cancelHash[this.orderRefund.refundHeader.refundReason] &&
        this.cancelHash[this.orderRefund.refundHeader.refundReason].enDesc) || '--'
    },
    sellerPhone() {
      if (this.orderData.orderDetail?.seller) {
        return this.orderData.orderDetail?.seller.phone.replace('+', '');
      }
      return '';
    }
  },
  watch: {
    detail: {
      handler(val) {
        val = val || {};
        if (!val.payments || !Array.isArray(val.payments)) return;
        this.serviceTypeStatus = val.serviceType;
        if (val.shipment) {
          this.shipmentStatusCode = val.shipment.trackingStatusCode;
          this.paymentMethodType = val.payments?.[0].paymentMethodType;
          this.shipmentExternalId = val.shipment.externalId;
        }
        this.paymentMethodTypeId = val.payments?.[0]?.paymentMethodTypeId;
        this.needOfflineRefund = val.payments?.[0]?.needOfflineRefund;
        if (this.isOVO) {
          if (this.needOfflineRefund) {
            this.ovoTitleStr = this.$t('result.cancelMsg1');
            this.ovoStr = this.$t('result.cancelMsg2');
            console.log('needOfflineRefund true 取消订单');
            return;
          }
          const cancelTime = val.cancelledTime.localeStamp1
            .trim()
            .split(' ')?.[0];
          const createTime = val.createdTime.localeStamp1.trim().split(' ')?.[0];
          if (cancelTime === createTime) {
            this.ovoTitleStr = this.$t('result.cancelOvoSameTitle');
            this.ovoStr = this.$t('result.cancelOvoSame');
          } else {
            this.ovoTitleStr = this.$t('result.cancelMsg1');
            this.ovoStr = this.$t('result.cancelMsg2');
          }
        }
      },
      deep: true,
      immediate: true,
    }
  },
  mounted() {
    if (window.history && window.history.pushState) {
      // 历史记录 插入当前界面
      window.history.pushState(null, null, document.URL);
      window.addEventListener('popstate', this.goBack, false);
    }
    getCancelReasonList().then((res) => {
      this.cancelHash = {};
      res.data.forEach(item => {
        if (!this.cancelHash[item.reason]) {
          this.cancelHash[item.reason] = {};
        }
        this.cancelHash[item.reason] = item
      })
    })
  },
  destroyed() {
    window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    goBack() {
      window.history.pushState(null, null, document.URL);
    },
  },
};
</script>

<style lang="scss" scoped>
.mt-100px {
  margin-top: 100px;
}
.resultCanceled {
  background: url('~src/assets/images/result/canceledBg.png') no-repeat center;
  background-size: contain;
  padding-bottom: 16px !important;
  .q-icon {
    width: 64px;
    height: 64px;
    margin: 120px auto 16px;
  }
  .title {
    margin-top: 0 !important;
    line-height: 120%;
    color: $negative;
    margin-top: 125px;
  }
  .desc {
    line-height: 16px;
  }
  .refund-text {
    color: #232323;
    text-align: center;
    /* body Gotham */
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 128.571% */
  }
  .order-cancel-container {
    .cancel-track {
      margin-top: 16px;
    }
    .cancel-reason-container {
      margin-top: 16px;
      width: 100%;
      background: var(--Grey-100, #F3F4F6);
      border-radius: 8px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      .title {
        color: var(--Black, #000);
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%; /* 19.2px */
        text-align: left;
        margin: 0;
      }
      .reason-label {
        color: #757575;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 14.4px */
        text-align: left;
        margin: 0;
      }
      .reason-desc {
        color: #757575;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 120%; /* 14.4px */
        text-align: left;
        margin: 0;
      }

    }
    .cancel-contact-container {
      margin-top: 16px;
      width: 100%;
      height: 64px;
      padding: 10px 16px;
      display: flex;
      justify-content: space-between;
      gap: 8px;
      background-color: var(--Grey-100, #F3F4F6);
      border-radius: 8px;

      .contact-phone {
        height: 44px;
        width: 44px;
        border-radius: 50%;
        background-color: #fff;
        text-align: center;
        line-height: 44px;
        border: 1px solid #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        .contact-icon {
          margin: 0;
          width: 24px;
          height: 24px;
        }
      }
      .contact-btn {
        background: #C63527;
        border-radius: 1000px;
        height: 44px;
        text-align: center;
        line-height: 44px;
        color: #FFFFFF;
        /* Inter/Bold/M */
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        flex: 1;
      }
    }
  }
}
</style>
